var _mask, _path, _mask2, _path2, _mask3, _path3, _mask4, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_930_2600",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1755 42.1753C39.9914 41.5901 37.944 40.5804 36.1501 39.204C34.3563 37.8275 32.8511 36.1112 31.7205 34.153C30.59 32.1948 29.8562 30.0331 29.561 27.7913C29.2659 25.5496 29.4152 23.2716 30.0004 21.0876C30.5857 18.9035 31.5953 16.8561 32.9718 15.0622C34.3483 13.2684 36.0646 11.7632 38.0228 10.6326C39.981 9.50206 42.1427 8.76827 44.3844 8.47314C46.6262 8.178 48.9041 8.32731 51.0882 8.91253L46.6318 25.5439L42.1755 42.1753Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1755 42.1753C39.9914 41.5901 37.944 40.5804 36.1501 39.204C34.3563 37.8275 32.8511 36.1112 31.7205 34.153C30.59 32.1948 29.8562 30.0331 29.561 27.7913C29.2659 25.5496 29.4152 23.2716 30.0004 21.0876C30.5857 18.9035 31.5953 16.8561 32.9718 15.0622C34.3483 13.2684 36.0646 11.7632 38.0228 10.6326C39.981 9.50206 42.1427 8.76827 44.3844 8.47314C46.6262 8.178 48.9041 8.32731 51.0882 8.91253L46.6318 25.5439L42.1755 42.1753Z",
    fill: "url(#paint0_linear_930_2600)",
    stroke: "black",
    mask: "url(#path-1-inside-1_930_2600)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_930_2600",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1757 42.1753C44.3598 42.7605 46.4072 43.7702 48.2011 45.1466C49.9949 46.5231 51.5001 48.2394 52.6307 50.1976C53.7612 52.1558 54.495 54.3175 54.7901 56.5593C55.0853 58.801 54.936 61.079 54.3508 63.263C53.7655 65.4471 52.7559 67.4945 51.3794 69.2884C50.0029 71.0822 48.2866 72.5874 46.3284 73.718C44.3702 74.8485 42.2085 75.5823 39.9668 75.8774C37.725 76.1726 35.4471 76.0233 33.263 75.4381L37.7194 58.8067L42.1757 42.1753Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1757 42.1753C44.3598 42.7605 46.4072 43.7702 48.2011 45.1466C49.9949 46.5231 51.5001 48.2394 52.6307 50.1976C53.7612 52.1558 54.495 54.3175 54.7901 56.5593C55.0853 58.801 54.936 61.079 54.3508 63.263C53.7655 65.4471 52.7559 67.4945 51.3794 69.2884C50.0029 71.0822 48.2866 72.5874 46.3284 73.718C44.3702 74.8485 42.2085 75.5823 39.9668 75.8774C37.725 76.1726 35.4471 76.0233 33.263 75.4381L37.7194 58.8067L42.1757 42.1753Z",
    fill: "url(#paint1_linear_930_2600)",
    stroke: "black",
    mask: "url(#path-2-inside-2_930_2600)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_930_2600",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1754 42.1757C41.5902 44.3598 40.5806 46.4072 39.2041 48.2011C37.8276 49.9949 36.1113 51.5001 34.1531 52.6307C32.1949 53.7612 30.0332 54.495 27.7915 54.7901C25.5497 55.0853 23.2717 54.936 21.0877 54.3508C18.9036 53.7655 16.8562 52.7559 15.0623 51.3794C13.2685 50.0029 11.7633 48.2866 10.6327 46.3284C9.50219 44.3702 8.76839 42.2085 8.47326 39.9668C8.17813 37.725 8.32743 35.4471 8.91265 33.263L25.544 37.7194L42.1754 42.1757Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1754 42.1757C41.5902 44.3598 40.5806 46.4072 39.2041 48.2011C37.8276 49.9949 36.1113 51.5001 34.1531 52.6307C32.1949 53.7612 30.0332 54.495 27.7915 54.7901C25.5497 55.0853 23.2717 54.936 21.0877 54.3508C18.9036 53.7655 16.8562 52.7559 15.0623 51.3794C13.2685 50.0029 11.7633 48.2866 10.6327 46.3284C9.50219 44.3702 8.76839 42.2085 8.47326 39.9668C8.17813 37.725 8.32743 35.4471 8.91265 33.263L25.544 37.7194L42.1754 42.1757Z",
    fill: "url(#paint2_linear_930_2600)",
    stroke: "black",
    mask: "url(#path-3-inside-3_930_2600)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_930_2600",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1761 42.1761C42.7613 39.992 43.771 37.9446 45.1475 36.1507C46.524 34.3569 48.2403 32.8517 50.1985 31.7211C52.1567 30.5906 54.3183 29.8568 56.5601 29.5617C58.8019 29.2665 61.0798 29.4158 63.2639 30.0011C65.448 30.5863 67.4954 31.5959 69.2892 32.9724C71.0831 34.3489 72.5883 36.0652 73.7188 38.0234C74.8494 39.9816 75.5832 42.1433 75.8783 44.385C76.1734 46.6268 76.0241 48.9048 75.4389 51.0888L58.8075 46.6324L42.1761 42.1761Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1761 42.1761C42.7613 39.992 43.771 37.9446 45.1475 36.1507C46.524 34.3569 48.2403 32.8517 50.1985 31.7211C52.1567 30.5906 54.3183 29.8568 56.5601 29.5617C58.8019 29.2665 61.0798 29.4158 63.2639 30.0011C65.448 30.5863 67.4954 31.5959 69.2892 32.9724C71.0831 34.3489 72.5883 36.0652 73.7188 38.0234C74.8494 39.9816 75.5832 42.1433 75.8783 44.385C76.1734 46.6268 76.0241 48.9048 75.4389 51.0888L58.8075 46.6324L42.1761 42.1761Z",
    fill: "url(#paint3_linear_930_2600)",
    stroke: "black",
    mask: "url(#path-4-inside-4_930_2600)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_930_2600",
    x1: 60.2103,
    y1: 20.4255,
    x2: 25.8633,
    y2: 54.7816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_930_2600",
    x1: 24.1409,
    y1: 63.9251,
    x2: 58.4879,
    y2: 29.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_930_2600",
    x1: 20.4256,
    y1: 24.1409,
    x2: 54.7818,
    y2: 58.4879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_930_2600",
    x1: 63.926,
    y1: 60.2109,
    x2: 29.5698,
    y2: 25.8639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerIcon);
export default __webpack_public_path__ + "static/media/flower-icon.70191ce35a8fc82e2fd94d59d76d0bde.svg";
export { ForwardRef as ReactComponent };